import React, { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

function ProviderLogin() {
    const [credentials, setCredentials] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);
    const { loginUser } = useContext(AuthContext);
    const navigate = useNavigate();
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            const response = await axios.post(
                `${import.meta.env.VITE_URL_PROVIDER}/login`,
                credentials
            );
            
            loginUser(response.data.token, 'provider');
            
            Swal.fire({
                icon: "success",
                title: "Welcome!",
                text: "Login successful",
                timer: 1500,
                showConfirmButton: false
            });
            
            // Use React Router navigation instead of window.location.href
            setTimeout(() => {
                navigate('/provider-dashboard');
            }, 500);
            
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Login Error",
                text: error.response?.data?.message || "Login failed"
            });
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={6} lg={4}>
                    <Card>
                        <CardHeader className="text-center">
                            <h3>Provider Login</h3>
                        </CardHeader>
                        <CardBody>
                            <Form onSubmit={handleSubmit}>
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input
                                        type="email"
                                        id="email"
                                        placeholder="Enter your email"
                                        value={credentials.email}
                                        onChange={(e) => setCredentials({...credentials, email: e.target.value})}
                                        required
                                        disabled={loading}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="password">Password</Label>
                                    <Input
                                        type="password"
                                        id="password"
                                        placeholder="Enter your password"
                                        value={credentials.password}
                                        onChange={(e) => setCredentials({...credentials, password: e.target.value})}
                                        required
                                        disabled={loading}
                                    />
                                </FormGroup>
                                <Button 
                                    type="submit" 
                                    color="primary" 
                                    block 
                                    disabled={loading}
                                    className="mt-3"
                                >
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Logging in...
                                        </>
                                    ) : (
                                        "Login"
                                    )}
                                </Button>
                            </Form>
                            
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
}

export default ProviderLogin;